<select #comboBox
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [(ngModel)]="selectedCodeValue" [disabled]="disabled" [hidden]="!visible"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [class.combo-box-required]="required" [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.codeList">
    <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
  </ng-template>
</select>
